import React, { useCallback, useEffect, useMemo, useRef } from 'react';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import * as Const from '../../utils/Const';
import { GetKeyEndTypes, GetSummaryRuleOptionId, GetOrgId } from '../../utils/UtilFunction';
import { useGetDashboardData } from './api/fetchData';
import { GraphAreaStudyDetail } from './GraphAreaStudyDetail';
import Sidebar from '../../components/sidemenu/Sidebar';

export function DashboardSelfStudyDetail() {
  // React Router の useSearchParams フックを使用
  const [searchParams, setSearchParams] = useSearchParams();
  const urlParamStartDateTime = searchParams.get('startDateTime') || '';
  const urlParamToDateTime = searchParams.get('toDateTime') || '';
  const urlParamEndType = searchParams.get('endType') || '';
  // const urlParamOrgId = searchParams.get('orgId') || '';
  const urlParamSummaryItem = searchParams.get('summaryItem') || '';
  // const urlParamSummaryRuleName = searchParams.get('summaryRuleName') || '';

  const [fromDate, setFromDate] = useState<Date | null>(
    urlParamStartDateTime ? new Date(urlParamStartDateTime) : null
  );
  const [toDate, setToDate] = useState<Date | null>(
    urlParamToDateTime ? new Date(urlParamToDateTime) : null
  );
  // const [orgId, setOrgId] = useState<string | null>(urlParamOrgId);
  const orgId = GetOrgId();
  const [summaryItem, setSummaryItem] = useState<string>(urlParamSummaryItem);
  // const [summaryRuleName, setSummaryRuleName] = useState<string | null>(urlParamSummaryRuleName);
  const [selectedEndTypes, setSelectedEndTypes] = useState<string[]>(
    urlParamEndType ? urlParamEndType.split(',') : []
  );

  const summaryDetailTableDataUrl = `${
    import.meta.env.VITE_DATA_POOLS_URL
  }/selectSummaryDetailTableData`;

  //TODO hasLoadedが必要かチェックする
  const hasLoaded = useRef(false);

  const dataParams = useMemo(
    () => ({
      [Const.KeyOrgID]: orgId || '',
      [Const.KeyType]: summaryItem,
      [Const.KeyStartDatetimeUtc]: fromDate?.toJSON() || '',
      [Const.KeyEndDatetimeUtc]: toDate?.toJSON() || '',
      [Const.KeyEndType]: GetKeyEndTypes(selectedEndTypes),
      // [Const.KeySummaryFilterCondition]: JSON.stringify(summaryRuleName),
    }),
    [orgId, summaryItem, fromDate, toDate, selectedEndTypes]
  );

  // URL のクエリパラメータを検索項目に反映
  useEffect(() => {
    setFromDate(urlParamStartDateTime ? new Date(urlParamStartDateTime) : null);
    setToDate(urlParamToDateTime ? new Date(urlParamToDateTime) : null);
    setSelectedEndTypes(urlParamEndType ? urlParamEndType.split(',') : selectedEndTypes);
    // setOrgId(urlParamOrgId ? urlParamOrgId : orgId);
    setSummaryItem(urlParamSummaryItem ? urlParamSummaryItem : summaryItem);
    // setSummaryRuleName(urlParamSummaryRuleName ? urlParamSummaryRuleName : summaryRuleName);
    updateSearchParams();
    reloadData();
  }, []);

  // 入力内容を URL に追加
  // const updateSearchParams = useCallback(() => {
  //   const params = new URLSearchParams();
  //   if (fromDate) params.set('startDateTime', fromDate.toISOString());
  //   if (toDate) params.set('toDateTime', toDate.toISOString());

  //   // endTypeをカンマ区切りの文字列で設定
  //   if (selectedEndTypes.length > 0) {
  //     params.set('endType', selectedEndTypes.join(',')); // 配列をカンマ区切りの文字列に変換
  //   }

  //   // if (orgId) params.set('orgId', orgId);
  //   if (summaryItem) params.set('summaryItem', summaryItem);
  //   // if (summaryRuleName) params.set('summaryRuleName', summaryRuleName);
  //   // URLクエリパラメータを更新
  //   setSearchParams(params);
  // }, [fromDate, toDate, selectedEndTypes, summaryItem, setSearchParams]);
  // URL のクエリパラメータを検索項目に反映
  useEffect(() => {
    const urlParamStartDateTime = searchParams.get('startDateTime') || '';
    const urlParamToDateTime = searchParams.get('toDateTime') || '';
    const urlParamEndType = searchParams.get('endType') || '';
    const urlParamSummaryItem = searchParams.get('summaryItem') || '';
    setFromDate(urlParamStartDateTime ? new Date(urlParamStartDateTime) : null);
    setToDate(urlParamToDateTime ? new Date(urlParamToDateTime) : null);
    setSelectedEndTypes(urlParamEndType ? urlParamEndType.split(',') : selectedEndTypes);
    setSummaryItem(urlParamSummaryItem);
  }, [searchParams]);

  const updateSearchParams = () => {
    const params = new URLSearchParams();
    if (fromDate) params.set('startDateTime', fromDate.toISOString());
    if (toDate) params.set('toDateTime', toDate.toISOString());

    // endTypeをカンマ区切りの文字列で設定
    if (selectedEndTypes.length > 0) {
      params.set('endType', selectedEndTypes.join(',')); // 配列をカンマ区切りの文字列に変換
    }

    // if (orgId) params.set('orgId', orgId);
    if (summaryItem) params.set('summaryItem', summaryItem);
    // if (summaryRuleName) params.set('summaryRuleName', summaryRuleName);
    // URLクエリパラメータを更新
    setSearchParams(params);
  };

  function reloadData() {
    // グラフのデータ読み込み処理
    fetchSummaryDetailTableData();
  }
  // useEffect(() => {
  //   if (!hasLoaded.current && orgId !== null && summaryItem !== null) {
  //     reloadData();
  //     hasLoaded.current = true;
  //   }
  // }, [orgId, summaryItem]);

  const {
    data: summaryDetailTableData,
    loading: summaryDetailTableLoading,
    error: summaryDetailTableError,
    execute: fetchSummaryDetailTableData,
  } = useGetDashboardData(summaryDetailTableDataUrl, dataParams);

  if (summaryDetailTableLoading) return <p>Loading...</p>;
  if (summaryDetailTableError) {
    const errorMessage =
      summaryDetailTableError instanceof Error
        ? summaryDetailTableError.message
        : 'An unknown error occurred';
    return <p>Error: {errorMessage}</p>;
  }

  return (
    <>
      <Sidebar />
      <div
        style={{
          marginLeft: 40,
          width: 'calc(100% - 40px)',
          transition: 'width 0.3s, margin-left 0.3s',
        }}
      >
        <GraphAreaStudyDetail
          summaryDetailTableData={summaryDetailTableData}
          summaryItemId={Number(summaryItem)}
        ></GraphAreaStudyDetail>
      </div>
    </>
  );
}

export default DashboardSelfStudyDetail;
